import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../layout/theme-next';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) =>
  createStyles({
    chip: {
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '11px 0px 11px 10px',
      background: Colors.primaryHighlight,
      '&:hover': {
        cursor: 'pointer',
      },
      height: '100%',
      marginBottom: '10px',
      '& .MuiChip-label': {
        padding: '0px',
      },
    },
    label: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: Colors.primary,
      padding: '0px',
    },
    link: {
      textDecoration: 'none',
      color: Colors.primary,
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17.64px',
    },
    header: {
      fontSize: '12px',
      color: Colors.textBlack,
      fontWeight: 600,
      lineHeight: '15.12px',
      marginBottom: '10px',
    },
    noHeader: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: Colors.textBlack,
    },
    avatarSection: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '10px',
    },
    selectedUsersGrid: {
      borderRadius: '4px',
      background: Colors.primaryHighlight,
      marginTop: '5px',
      marginBottom: '10px',
      padding: '5px 5px 5px 10px',
      flexWrap: 'nowrap',
      width: '203px',
      '&:hover': {
        background: Colors.fieldDisabled,
        borderRadius: '4px',
        '& $deleteIcon': {
          visibility: 'visible',
        },
      },
      '&.groupsGrid': {
        padding: '11px 5px 10px 10px',
      },
    },
    deleteIcon: {
      display: 'flex',
      alignItems: 'center',
      visibility: 'hidden',
    },
    externalReferencesBox: {
      marginBottom: theme.spacing(2.5),
    },
    externalRefDetails: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      rowGap: theme.spacing(0.5),
      columnGap: theme.spacing(0.625),
    },
    row: {
      display: 'contents',
    },
    title: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
    },
    value: {
      wordBreak: 'break-word',
    },
  }));
